export const UpsellEmbedHomepage = (_props: { location: string }) => {
  // IAS overlay: no premium-plan promo CTAs.
  return null;
};
